module.exports = __webpack_public_path__ + "static/nearby-walker-08c62d9fcd05e4720e34fa3bea2124e0.svg";